// import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App.jsx";
import reportWebVitals from "./reportWebVitals.js";
import { Provider } from "react-redux";

import { configureStore } from "./redux/reducers/index.js";
import { AuthContextProvider } from "./store/auth-context.js";
import { ConfigureProvider } from "./store/ConfigureContext.js";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ConfigureProvider>
    <AuthContextProvider>
      <Provider store={configureStore()}>
        <App />
      </Provider>
    </AuthContextProvider>
  </ConfigureProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();